import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { TableBody } from '@material-ui/core';

import configData from "../../../config.json";

const apiUrl = (process.env.NODE_ENV !== 'development') ? configData.EndPoint : configData.EndPointLocal;

const useStyles = makeStyles({
    table: {
        minWidth: 250,
    },
});


const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};


export const TablePago = ({ tableProps }: any) => {
    const classes = useStyles();

    const query = useQuery();
    const cupon: any = query.get("cupon");  // cupon de descuento

    const isMexico: boolean = tableProps.Escuela.DatosInstitucion.pais === 'MEXICO' ? true : false;
    const numeroAlumnos: number = tableProps.Escuela.DatosInstitucion.numero_alumnos;
    const precioUnitario: number = isMexico ? 25 : 1;
    const subtotal: number = numeroAlumnos * precioUnitario;
    const iva: number = 0.16;
    const subtotalWithIva = ((subtotal * iva) + subtotal);

    useEffect(() => {
        fetch(`${apiUrl}/index.php/Cupones/validate/?codigo=${cupon}`)
            .then(response => response.json())
            .then(er => console.log(er))
            .catch((err) => console.error(err));
    }, [cupon]);

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} size="small">
                <TableBody>

                    {cupon && (
                        <TableRow>
                            <TableCell variant="head" component="th" scope="row">Cupon:</TableCell>
                            <TableCell> {cupon} </TableCell>
                        </TableRow>
                    )}

                    <TableRow>
                        <TableCell variant="head" component="th" scope="row">Costo por alumno:</TableCell>
                        <TableCell> ${precioUnitario} <br /> {isMexico ? 'MXN' : 'USD'} </TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell variant="head" component="th" scope="row">No. alumnos:</TableCell>
                        <TableCell> {numeroAlumnos} </TableCell>
                    </TableRow>

                    {isMexico && (
                        <TableRow>
                            <TableCell variant="head" component="th" scope="row">IVA 16%:</TableCell>
                            <TableCell> {(subtotal * iva)} </TableCell>
                        </TableRow>
                    )}

                    <TableRow>
                        <TableCell variant="head" component="th" scope="row">Subtotal:</TableCell>
                        <TableCell> ${isMexico ? subtotalWithIva : subtotal} <br /> {isMexico ? 'MXN' : 'USD'} </TableCell>
                    </TableRow>

                </TableBody>
            </Table>
        </TableContainer>
    );
}